import { Badge, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useBidStepLabel, visibleBidSteps, type BidStep } from "./bidWizardSteps";

interface Props {
  currentStep: BidStep;
  navigateToStep: (step: BidStep) => void;
  collectSupplierPrice: boolean;
}

export const BidWizardNav = ({ currentStep, navigateToStep, collectSupplierPrice }: Props) => {
  const { t } = useTranslation();
  const stepLabel = useBidStepLabel();

  return (
    <Stack spacing="1">
      {visibleBidSteps(collectSupplierPrice).map(({ key, icon, live }, index) => {
        const isCurrent = key === currentStep;
        return (
          <Flex
            key={key}
            align="center"
            gap="3"
            px="3"
            py="2"
            borderRadius="md"
            cursor={live ? "pointer" : "not-allowed"}
            opacity={live ? 1 : 0.5}
            bg={isCurrent ? "smPrimarySofter" : undefined}
            color={isCurrent ? "smPrimary" : "smText"}
            _hover={live && !isCurrent ? { bg: "smBackgroundTertiary" } : undefined}
            onClick={() => live && navigateToStep(key)}
          >
            <Flex
              align="center"
              justify="center"
              boxSize="7"
              borderRadius="full"
              bg={isCurrent ? "smPrimary" : "smBackgroundTertiary"}
              color={isCurrent ? "white" : "smMuted"}
              flexShrink={0}
            >
              <Icon as={icon} boxSize="3.5" />
            </Flex>
            <Stack spacing="0.5" flex="1" minW="0">
              <Text fontSize="sm" fontWeight={isCurrent ? "semibold" : "medium"}>
                {`${index + 1}. ${stepLabel(key)}`}
              </Text>
              {!live && (
                <Badge alignSelf="flex-start" colorScheme="gray" fontSize="2xs">
                  {t("Coming soon")}
                </Badge>
              )}
            </Stack>
          </Flex>
        );
      })}
    </Stack>
  );
};
